import { Convert } from "./convert";

export class KeyPair {
  public secretKey: string;
  public publicKey: string;

  constructor() {}

  public encode(): string {
    var serialized = JSON.stringify(this);
    var encoder = new TextEncoder();

    return Convert.toBase64String(encoder.encode(serialized));
  }

  public static decode(source: string): KeyPair {
    var uint8 = Convert.fromBase64String(source);
    var decoder = new TextDecoder();
    var decoded = decoder.decode(uint8);
    var json = JSON.parse(decoded);
    if (json) {
      var key = new KeyPair();
      key.secretKey = json.secretKey;
      key.publicKey = json.publicKey;
      return key;
    } else {
      return null;
    }
  }
}
